var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rejected",
    transform: "translate(-1085 -3396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1085 3396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Disapproved_Icon",
    "data-name": "Disapproved Icon",
    d: "M20,0A20,20,0,1,0,40,20,20.022,20.022,0,0,0,20,0Zm7.365,25.008a1.666,1.666,0,1,1-2.357,2.357L20,22.357l-5.008,5.008a1.666,1.666,0,1,1-2.357-2.357L17.643,20l-5.008-5.008a1.666,1.666,0,0,1,2.357-2.357L20,17.643l5.008-5.008a1.666,1.666,0,1,1,2.357,2.357L22.357,20Z",
    transform: "translate(1085 3396)",
    fill: "#f07379"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.686b4c2aa0bab36ada62bceee8e1d1f7.svg";
export { ForwardRef as ReactComponent };